import { Reveal } from "@/components/site/Primitives";
import { BtnLink } from "@/components/site/Primitives";
import { CheckList, DiscoveryBand, PageHero } from "@/components/site/Blocks";
import { useLink, useT } from "@/lib/i18n";

const IMGS = {
  relocation: "/img/izola-harbour.jpg", admin: "/img/ljubljana.jpg", language: "/img/koper-street.jpg",
  housing: "/img/slovenia-hills.jpg", mediation: "/img/izola-boats.jpg", corporate: "/img/ljubljana-canal.jpg",
};

export default function Services() {
  const t = useT();
  const link = useLink();
  const p = t.servicesPage;
  return (
    <div data-testid="services-page">
      <PageHero eyebrow={p.eyebrow} title={p.title} intro={p.intro} image="/img/coast-sunset.jpg" imageAlt="Slovenska obala" />
      <section className="container-x space-y-6 pb-8">
        {t.services.items.map((it, i) => (
          <Reveal key={it.key}>
            <article data-testid={`services-page-${it.key}`} className="card-soft grid overflow-hidden md:grid-cols-12">
              <img src={IMGS[it.key]} alt="" loading="lazy" className={`h-56 w-full object-cover md:col-span-4 md:h-full ${i % 2 ? "md:order-2" : ""}`} />
              <div className="p-8 sm:p-10 md:col-span-8 lg:p-12">
                <span className="font-display text-xl italic text-gold-text">0{i + 1}</span>
                <h2 className="mt-2 font-display text-3xl leading-tight text-forest sm:text-4xl">{it.title}</h2>
                <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-forest/75 sm:text-base">{it.text}</p>
                <div className="mt-6"><CheckList items={it.points} /></div>
                <BtnLink to={link(it.to === "apply" ? "apply" : it.to)} variant="forest" className="mt-8" data-testid={`services-page-${it.key}-btn`}>{it.cta}</BtnLink>
              </div>
            </article>
          </Reveal>
        ))}
        <p className="pt-4 text-sm text-forest/70" data-testid="services-price-note">{p.priceNote}</p>
      </section>
      <DiscoveryBand />
    </div>
  );
}
